import { useTypeSelector } from '../useTypeSelector';

export const useAuth = () => {
  return useTypeSelector((state) => state.auth);
};
